<span [matTooltip]="getTooltip() | translate">

  <span *ngIf="getMatIcon()">
    <mat-icon>
      {{ getMatIcon() | translate }}
    </mat-icon>
  </span>

  {{ getValue() }}
</span>
